import { Box, Divider, Grid, makeStyles, Typography } from "@material-ui/core";
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
} from "chart.js";
import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { useAppDispatch } from "src/app-redux/hooks";
import {
  getVehicleAction,
  getVehicleActionLevelThree,
  getVehicleActionLevelTwo,
} from "src/app-redux/insights/actions/insightsActions";
import { IVehicleInsights } from "src/common/typings/insights";
import CommonDialog from "src/components/AlertDialog/CommonDialog";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import { columns } from "../../../vehicle/columns";
import { GridRowModel } from "@material-ui/x-grid";
import { Button, Tooltip } from "@mui/material";
import { Check, Close } from "@material-ui/icons";
import DoughnutChart from "./components/doughnut";
import { BBFColor, GDColor, statusColor } from "./components/utils";
import moment from "moment";
import "moment-timezone";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";

ChartJS.register(ArcElement, Legend, CategoryScale, LinearScale, BarElement, Title);

interface Props {
  startDate: string;
  endDate: string;
}

const useStyles = makeStyles(() => ({
  heading: {
    fontSize: "16px",
    fontWeight: 700,
    marginBottom: "15px",
  },
  icons: {
    margin: "1px 10px 15px 0",
    height: "17px",
  },
  revenueAmount: {
    fontSize: "22px",
    fontWeight: 600,
    color: "#488CFB",
    marginBottom: "15px",
  },
  statusItem: {
    borderBottom: "1px solid #E6E6E6",
    padding: "10px 10px",
    // marginBottom: "10px",
  },
  statusAmount: {
    fontSize: "14px",
    textAlign: "right",
  },
  vehiclesItem: {
    border: "0.5px solid #E6E6E6",
    borderRadius: "8px",
    boxShadow: "0px 0px 2px #00000029",
    padding: "15px 15px 0 15px",
    marginBottom: "15px",
  },
  scrollbar: {
    height: "35px",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      width: 10,
      height: 10,
    },
  },
}));

export function Vehicles({ startDate, endDate }: Props): React.ReactElement {
  const isExportString = localStorage.getItem("isAllowToExportData");
  const isExport = isExportString === "true";
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const [totalAmountVehicles, setTotalAmountVehicles] = useState<number>(0);
  const [vehiclesLever2List, setVehiclesLevel2List] = useState<any>([]);
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const [vehicleRecord, setvehicleRecord] = React.useState<GridRowModel[]>([]);
  const [loader, setLoader] = useState<any>(false);
  const [vehicleConsignmentStats, setVehicleConsignmentStats] = useState<any>([]);
  const [colors, setColors] = useState<any>([]);
  const [totalAmountVehiclesStatus, setTotalAmountVehiclesStatus] = useState<number>(0);
  const [totalAmountVehiclesBBF, setTotalAmountVehiclesBBF] = useState<number>(0);
  const [vehicleStatusList, setVehicleStatusList] = useState<any>([]);
  const [vehicleBBFList, setVehicleBBFList] = useState<any>([]);
  const [vehicleGDList, setVehicleGDList] = useState<any>([]);
  const [totalAmountVehiclesGD, setTotalAmountVehiclesGD] = useState<number>(0);

  const getNewColorCode: any = () => {
    const colorCode = `#${Math.floor(Math.random() * 0xffffff).toString(16)}`;
    return colorCode.length == 7 ? colorCode : getNewColorCode();
  };

  const [barChartDataLevel2, setBarChartDataLevel2] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "Vehicle Status",
        data: [],
        backgroundColor: "#FFD500",
        borderRadius: 50,
        barThickness: 10,
      },
    ],
  });

  const [isOpenDailogLevelThree, setIsOpenDailogLevelThree] = useState(false);
  const [isOpenDailogLevelTwo, setIsOpenDailogLevelTwo] = useState(false);
  const [chartHeadeingLevel2, setChartHeadeingLevel2] = useState({
    status: "",
    count: "",
  });
  const [chartHeadeingLevel3, setChartHeadeingLevel3] = useState({
    consignmentType: "",
    count: "",
  });
  const [chartHeadeingLevel3Payload, setChartHeadeingLevel3Payload] = useState({
    startDate: startDate,
    endDate: endDate,
    vehicleStatus: "",
    consignmentType: "",
    isBbfVehicle: false,
  });
  const toggleDialogLevelTwo = async (vehicle: any, isBbfVehicle: any) => {
    const { vehicleStatus } = vehicle;
    setChartHeadeingLevel2({
      status: vehicleStatus,
      count: vehicle?.count,
    });
    getVehicleInsightLevelTwo(startDate, endDate, vehicleStatus, isBbfVehicle);
    setIsOpenDailogLevelTwo(!isOpenDailogLevelTwo);
  };

  const getVehicleInsightLevelTwo = async (
    startDate: string,
    endDate: string,
    vehicleStatus: string,
    isBbfVehicle: any
  ) => {
    const req: any = {
      startDate: startDate,
      endDate: endDate,
      vehicleStatus: vehicleStatus,
      isBbfVehicle: isBbfVehicle,
      IsCommercialVehicles: false,
      isNodRequest: false,
    };
    setChartHeadeingLevel3Payload({
      ...chartHeadeingLevel3Payload,
      vehicleStatus: vehicleStatus,
      isBbfVehicle: isBbfVehicle,
    });
    const res = await dispatch(getVehicleActionLevelTwo(req));

    if (res.payload) {
      setVehiclesLevel2List(res.payload.vehicleConsignmentStatsModel);
      setBarChartDataLevel2({
        labels: res.payload.vehicleConsignmentStatsModel.map((item: any) => {
          return item.consignmentType;
        }),
        datasets: [
          {
            label: "Vehicle count",
            data: res.payload.vehicleConsignmentStatsModel.map((item: any) => {
              return item.count;
            }),
            backgroundColor: "#FFD500",
            borderRadius: 50,
            barThickness: 10,
          },
        ],
      });
    }
  };

  const barChartOptionsLevel2 = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        min: 0,
        ticks: {
          stepSize: 1,
        },
      },
    },
    onHover: (event: any, chartElement: any) => {
      event.native.target.style.cursor = chartElement.length ? "pointer" : "default";
    },
    onClick: async (event: any, chartElement: any) => {
      if (chartElement?.length > 0) {
        const index = chartElement[0]?.index;
        setChartHeadeingLevel3({
          consignmentType: vehiclesLever2List[index]?.consignmentType,
          count: vehiclesLever2List[index]?.count,
        });
        toggleDialogLevelThree();
        setChartHeadeingLevel3Payload({
          ...chartHeadeingLevel3Payload,
          consignmentType: vehiclesLever2List[index]?.consignmentType,
        });
        const { vehicleStatus, isBbfVehicle } = chartHeadeingLevel3Payload;
        const consignmentType = vehiclesLever2List[index]?.consignmentType;

        getVehicleInsightLevelThree(
          startDate,
          endDate,
          vehicleStatus,
          consignmentType,
          isBbfVehicle
        );
      }
    },
  };

  const toggleDialogLevelThree = async () => {
    setIsOpenDailogLevelThree(!isOpenDailogLevelThree);
  };

  const getVehicleInsightLevelThree = async (
    startDate: string,
    endDate: string,
    vehicleStatus: string,
    consignmentType: string,
    isBbfVehicle: boolean
  ) => {
    const req: any = {
      StartDate: startDate,
      EndDate: endDate,
      VehicleStatus: vehicleStatus,
      ConsignmentType: consignmentType,
      isBbfVehicle: isBbfVehicle,
      isNodRequest: false,
    };
    setvehicleRecord([]);
    setLoader(true);
    const res = await dispatch(getVehicleActionLevelThree(req));

    if (res.payload) {
      setvehicleRecord(res?.payload?.gateEnteries);
      setLoader(false);
    }
  };

  useEffect(() => {
    if (vehicleRecord.length) {
      const transformedColumns: any = columns.map((column: any) =>
        column.accessorKey === "vehicleInProgress"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      <Tooltip title={row.original?.vehicleInProgress ? "Yes" : "No"}>
                        <Button style={{ minWidth: "30px", padding: "4px", color: "gray" }}>
                          {row.original?.vehicleInProgress ? <Check /> : <Close />}
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column.accessorKey === "isAnomlyDetected"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      <Tooltip title={row.original?.isAnomlyDetected ? "Yes" : "No"}>
                        <Button style={{ minWidth: "30px", padding: "4px", color: "gray" }}>
                          {row.original?.isAnomlyDetected ? <Check /> : <Close />}
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column
      );

      setDisplayColumns(transformedColumns);
    }
  }, [vehicleRecord]);

  useEffect(() => {
    getVehicleInsight(startDate, endDate);
  }, [startDate, endDate]);

  const getVehicleInsight = async (startDate: string, endDate: string) => {
    const req: IVehicleInsights = {
      startDate: startDate,
      endDate: endDate,
      isNodRequest: false,
    };
    const res = await dispatch(getVehicleAction(req));

    if (res.payload) {
      // Vehicles
      const colors = res.payload.vehicleConsignmentStats.map(() => {
        const colorCode = getNewColorCode();
        return colorCode;
      });
      setColors(colors);

      setVehicleConsignmentStats(res.payload.vehicleConsignmentStats);
      setTotalAmountVehicles(
        res.payload.vehicleConsignmentStats.reduce(
          (partialSum: any, a: any) => partialSum + a.count,
          0
        )
      );
      // Vehicle Status
      setTotalAmountVehiclesStatus(
        res.payload?.vehicleStatusStats?.reduce(
          (partialSum: any, a: any) => partialSum + a.count,
          0
        )
      );
      setTotalAmountVehiclesGD(
        res.payload?.gdBindedVehicles?.reduce((partialSum: any, a: any) => partialSum + a.count, 0)
      );
      setTotalAmountVehiclesBBF(
        res.payload?.bBFVehicleStatusStats?.reduce(
          (partialSum: any, a: any) => partialSum + a.count,
          0
        )
      );
      setVehicleStatusList(res.payload.vehicleStatusStats);
      setVehicleBBFList(res.payload.bBFVehicleStatusStats);
      setVehicleGDList(res.payload?.gdBindedVehicles);
    }
  };

  const exportHandler = async (row: any) => {
    dispatch(
      addNotificationAction({
        message: "Your download will begin shortly",
        options: { variant: "success" },
      })
    );
    const exportedRecords = await row?.map((data: any) => {
      return {
        Vehicle: data?.vehicleNumber,
        Driver: data?.driverName,
        Type: data?.vehicleType,
        Status: data?.vehicleStatus,
        Consignment: data?.consignmentType,
        "GD #": data?.gdNumber,
        Location: data?.terminalLocation,
        Cargo: data?.cargoTypeName,
        Yard: data?.yardName,
        Entry: data.gateEntryDate ? moment(data.gateEntryDate).format("DD-MM-YYYY hh:mm:ss A") : "",
        Checkout: data.gateOutDate ? moment(data.gateOutDate).format("DD-MM-YYYY hh:mm:ss A") : "",
        Anomaly: data.isAnomlyDetected ? "Yes" : "No",
        "In Progress": data.vehicleInProgress ? "Yes" : "No",
        // Scan: data?.isScanComplete ? "Yes" : "No",
        // Weight: data?.isWeightDone ? "Yes" : "No",
        // Commercial: data?.isCommercialDone ? "Yes" : "No",
      };
    });
    return exportedRecords;
  };

  return (
    <>
      {/* Vehicle Section */}

      <Grid container item spacing={2} direction="row">
        {/* Doughnut */}
        <Grid item xs={12} md={6} lg={6}>
          <Box
            className={classes.vehiclesItem}
            sx={{
              // width: { xs: "100%", md: "80%" },
              height: { xs: "auto", md: "450px", xl: "500px" },
            }}
          >
            <Box>
              <Box m="auto" marginTop="10px">
                <DoughnutChart
                  vehicleConsignmentStats={vehicleConsignmentStats}
                  colors={colors}
                  totalAmountVehicles={totalAmountVehicles}
                />
              </Box>
            </Box>
          </Box>
        </Grid>
        {/* Vehicle Status */}
        <Grid item xs={12} md={6} lg={6}>
          <Box
            className={classes.vehiclesItem}
            sx={{
              // width: { xs: "100%", md: "80%" },
              height: { xs: "auto", md: "450px", xl: "500px" },
              marginLeft: { xs: 0, md: "2%", lg: 0 },
            }}
          >
            <Grid style={{ display: "flex" }} justifyContent="space-between" alignItems="center">
              <Box>
                <Typography variant="body1" component="p">
                  Vehicle Status:{" "}
                </Typography>
              </Box>
              <Box>
                <Typography variant="h5" component="p">
                  {totalAmountVehiclesStatus}{" "}
                </Typography>
              </Box>
            </Grid>
            <Box
              sx={{
                height: { xs: "110px", xl: "130px" },
              }}
              style={{ overflow: "auto" }}
            >
              {vehicleStatusList.map((item: any, index: number) => {
                return (
                  <Grid
                    container
                    direction="row"
                    key={item.vehicleStatus}
                    className={classes.statusItem}
                    style={{
                      backgroundColor: statusColor[index],
                      borderRadius: "4px",
                      cursor: "pointer",
                      marginTop: "10px",
                    }}
                    onClick={() => toggleDialogLevelTwo(item, false)}
                  >
                    <Grid item xs={10}>
                      <Typography>{item.vehicleStatus}</Typography>
                    </Grid>
                    <Grid item xs={2} className={classes.statusAmount}>
                      {item.count}
                    </Grid>
                  </Grid>
                );
              })}
            </Box>

            <Divider />
            {/* GD Vehicle */}
            <Grid
              style={{ display: "flex", marginTop: "5px" }}
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Typography variant="body1" component="p">
                  GD Vehicles:
                </Typography>
              </Box>
              <Box>
                <Typography variant="h5" component="p">
                  {totalAmountVehiclesGD}{" "}
                </Typography>
              </Box>
            </Grid>

            <Box
              sx={{
                height: { xs: "110px", xl: "130px" },
              }}
              style={{ overflow: "auto", marginBottom: "5px" }}
            >
              {vehicleGDList &&
                vehicleGDList?.map((item: any, index: number) => {
                  return (
                    <>
                      <Grid
                        container
                        direction="row"
                        key={item.vehicleStatus}
                        className={classes.statusItem}
                        style={{
                          backgroundColor: GDColor[index],
                          borderRadius: "4px",
                          cursor: "pointer",
                          marginTop: "10px",
                        }}
                        onClick={() => {
                          setChartHeadeingLevel3({
                            consignmentType: item.consignmentType,
                            count: item?.count,
                          });
                          getVehicleInsightLevelThree(
                            startDate,
                            endDate,
                            "Gd-vehicles",
                            item.consignmentType,
                            false
                          );
                          toggleDialogLevelThree();
                        }}
                      >
                        <Grid item xs={10}>
                          <Typography>{item.consignmentType}</Typography>
                        </Grid>
                        <Grid item xs={2} className={classes.statusAmount}>
                          {item.count}
                        </Grid>
                      </Grid>
                    </>
                  );
                })}
            </Box>

            <Divider />
            {/* BBF Vehicle */}
            <Grid
              style={{ display: "flex", marginTop: "5px" }}
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Typography variant="body1" component="p">
                  BBF Vehicles:
                </Typography>
              </Box>
              <Box>
                <Typography variant="h5" component="p">
                  {totalAmountVehiclesBBF}{" "}
                </Typography>
              </Box>
            </Grid>

            <Box
              sx={{
                height: { xs: "110px", xl: "130px" },
              }}
              style={{ overflow: "auto", marginBottom: "2px" }}
            >
              {vehicleBBFList &&
                vehicleBBFList?.map((item: any, index: number) => {
                  return (
                    <>
                      <Grid
                        container
                        direction="row"
                        key={item.vehicleStatus}
                        className={classes.statusItem}
                        style={{
                          backgroundColor: BBFColor[index],
                          borderRadius: "4px",
                          cursor: "pointer",
                          marginTop: "10px",
                        }}
                        onClick={() => toggleDialogLevelTwo(item, true)}
                      >
                        <Grid item xs={10}>
                          <Typography>{item.vehicleStatus}</Typography>
                        </Grid>
                        <Grid item xs={2} className={classes.statusAmount}>
                          {item.count}
                        </Grid>
                      </Grid>
                    </>
                  );
                })}
            </Box>
          </Box>
        </Grid>
      </Grid>
      <CommonDialog
        isOpen={isOpenDailogLevelTwo}
        handleClose={() => setIsOpenDailogLevelTwo(!isOpenDailogLevelTwo)}
        maxWidth="lg"
        heading={
          <Box display="flex" alignItems="center">
            <Typography className={classes.heading}>{chartHeadeingLevel2?.status}: </Typography>
            <Typography style={{ marginLeft: "10px" }} className={classes.revenueAmount}>
              {chartHeadeingLevel2?.count}
            </Typography>
          </Box>
        }
      >
        <Box className="insightsBarChart" m="auto">
          <Bar
            style={{ minWidth: "100vh", minHeight: "100%" }}
            options={barChartOptionsLevel2}
            data={barChartDataLevel2}
          />
        </Box>
      </CommonDialog>
      <CommonDialog
        isOpen={isOpenDailogLevelThree}
        handleClose={toggleDialogLevelThree}
        maxWidth="lg"
        heading={
          <Box display="flex" alignItems="center">
            <Typography className={classes.heading}>
              {chartHeadeingLevel3?.consignmentType}:{" "}
            </Typography>
            <Typography style={{ marginLeft: "10px" }} className={classes.revenueAmount}>
              {chartHeadeingLevel3?.count}
            </Typography>
          </Box>
        }
      >
        <CommonMaterialGrid
          rows={vehicleRecord}
          columns={displayColumns}
          loader={loader}
          defaultPerPageRecord={15}
          height={550}
          deletedRow={true}
          isExport={isExport}
          exportHandler={exportHandler}
          filename={`List_of_vehicle_${Date.now()}`}
        />
      </CommonDialog>
    </>
  );
}
